<template>
  <div class="row">
    <div class="col s12 z-depth-2" style="background-color: white; height: 100vh">
      <div class="row">
        <div class="col s12">
          <p style="margin-bottom: 0px">organisations</p>
        </div>
      </div>
      <div class="row">
        <div class="col s3">
          <a class="waves-effect waves-light btn" style="min-width: 150px" @click="navigateEditOrganisation(emptyOrganisationModel)">New organisation</a>
        </div>
        <div class="col s5">
        </div>
      <div class="row">
        <div class="col s12">
          <table class="striped">
            <thead>
              <tr>
                <th @click="orderOrganisationsByFilter('id')" class="clickable">Id
                  <i :style="{ color: orderOrganisationsBy.activeColumn === 'id' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderOrganisationsBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
                <th @click="orderOrganisationsByFilter('name')" class="clickable">Name
                  <i :style="{ color: orderOrganisationsBy.activeColumn === 'name' ? 'black' : 'white' }" class="material-icons">arrow_drop_{{ (orderOrganisationsBy.activeSortingDirection === 'asc' ? 'up' : 'down') }}</i>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(organisation, index) in allOrganisations" v-bind:key="index"
                  @click="navigateEditOrganisation(organisation)"
                  class="clickable"
                  >
                <td>{{ organisation.id }}</td>
                <td>{{ organisation.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import organisationsService from '@/services/api/OrganisationsApi'
import _ from 'lodash'

export default {
  data: function () {
    return {
      allOrganisations: undefined,
      orderOrganisationsBy: {
        activeSortingDirection: 'asc',
        activeColumn: undefined
      },
      emptyOrganisationModel: {
        name: ''
      }
    }
  },
  mounted: function () {
    this.getAllOrganisationsAndSetOrganisationsDropdown()
    // Initialize select boxes
    M.FormSelect.init(document.querySelectorAll('select'))
  },
  methods: {
    getAllOrganisationsAndSetOrganisationsDropdown: function () {
      organisationsService.getOrganisations().then(result => {
        console.log(result)
        this.allOrganisations = _.orderBy(result.data, 'id', ['asc'])
      })
    },
    orderOrganisationsByFilter: function (columnName) {
      this.orderOrganisationsBy.activeColumn = columnName
      if (this.orderOrganisationsBy.activeSortingDirection === 'asc') {
        this.orderOrganisationsBy.activeSortingDirection = 'desc'
        this.allOrganisations = _.orderBy(this.allOrganisations, columnName, ['desc'])
      } else {
        this.orderOrganisationsBy.activeSortingDirection = 'asc'
        this.allOrganisations = _.orderBy(this.allOrganisations, columnName, ['asc'])
      }
    },
    navigateEditOrganisation: function (organisationObject) {
      this.$router.push({ name: 'posseditorganisation', params: { 'organisation': organisationObject } })
    }
  }
}
</script>

<style scoped>
td {
  padding: 3px;
}

p {
  margin-top: 24px;
  margin-bottom: 24px;
}

/* BUTTON */
.btn-floating:hover {
  background-color: #F39810;
}

.btn:hover, .btn-large:hover, .btn-small:hover {
  background-color: #F39810;
}

.btn, .btn-large, .btn-small {
  background-color: #56CCF2;
}
</style>



// WEBPACK FOOTER //
// src/pages/organisations/Organisations.vue